'use strict';

export class ProjectLogs {
    static #timers = {};
    static #logs = {
        userData: {
            type: null,
            bandwidthSpeed: null,
            userAgent: navigator.userAgent
        },
        timeLog: {
            total: null,
            api: {
                props: -1,
                settings: -1,
                loader: -1
            },
            bundle: null
        }
    };

    constructor() {
        ProjectLogs.#measureUserBandwidthSpeed();
        ProjectLogs.#userDeviceType();
    }

    static get getLogs() {
        return ProjectLogs.#logs;
    }

    static timerStartFor(logType) {
        const splitLogType = logType.split("_");
        if (splitLogType.length > 1) {
            if (!ProjectLogs.#timers.hasOwnProperty(splitLogType[0]))
                ProjectLogs.#timers[splitLogType[0]] = {};

            ProjectLogs.#timers[splitLogType[0]][splitLogType[1]] = {
                start: performance.now()
            };
        } else {
            ProjectLogs.#timers[splitLogType[0]] = {
                start: performance.now()
            };
        }
    }

    static timerStopFor(logType) {
        const splitLogType = logType.split("_");
        if (!ProjectLogs.#timers.hasOwnProperty(splitLogType[0]))
            return;

        if (splitLogType.length > 1) {
            ProjectLogs.#timers[splitLogType[0]][splitLogType[1]].end = performance.now();

            const start = ProjectLogs.#timers[splitLogType[0]][splitLogType[1]].start;
            const end = ProjectLogs.#timers[splitLogType[0]][splitLogType[1]].end;

            ProjectLogs.#logs.timeLog[splitLogType[0]][splitLogType[1]] = (end - start).toFixed(2);
        } else {
            ProjectLogs.#timers[splitLogType[0]].end = performance.now();

            const start = ProjectLogs.#timers[splitLogType[0]].start;
            const end = ProjectLogs.#timers[splitLogType[0]].end;

            ProjectLogs.#logs.timeLog[splitLogType[0]] = (end - start).toFixed(2);
        }
    }

    static #measureUserBandwidthSpeed() {
        const img = new Image();
        let startTime, endTime;

        img.onload = function () {
            endTime = new Date().getTime();
            const duration = (endTime - startTime) / 1000; // in seconds
            const speed = (523 / duration).toFixed(2); // size of the image divided by duration
            ProjectLogs.#logs.userData.bandwidthSpeed = `${speed} KB/s`;
        };

        startTime = new Date().getTime();
        img.src = "https://dreamsimages.bmby.com/DreamsGeneralStorage/textures/water/water.jpg"; // Replace this URL with the URL of a small file on your server
    }

    static #userDeviceType() {
        const userAgent = navigator.userAgent;
        let deviceType;
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
            deviceType = "Mobile";
        } else if (/iPad/i.test(userAgent)) {
            deviceType = "Tablet";
        } else {
            deviceType = "Desktop";
        }

        ProjectLogs.#logs.userData.type = deviceType;
    }
}